export interface ExplorationTile {
  name: string
  regionName: string
  placesId: string
  destinationCategory: string
  imageSrc: string
}

export type ExplorationLocation = 'cornwall' | 'st_ives'

export interface ExplorationSets {
  location: ExplorationLocation
  v1: ExplorationTile[]
  v2: ExplorationTile[]
}

export const CORNWALL_PLACES_ID = '39247'
export const ST_IVES_PLACES_ID = '39380'

const tile = (
  name: string,
  placesId: string,
  destinationCategory: string,
  image: string,
): ExplorationTile => ({
  name,
  regionName: name,
  placesId,
  destinationCategory,
  imageSrc: `/exploration-suggestions/${image}.jpg`,
})

const NEWQUAY = tile('Newquay', '39351', 'england|cornwall|newquay', 'newquay')
const ST_IVES = tile('St Ives', '39380', 'england|cornwall|st ives', 'st-ives')
const ST_MAWES = tile(
  'St Mawes',
  '39363',
  'england|cornwall|st mawes',
  'st-mawes',
)
const NORTH_CORNWALL = tile(
  'North Cornwall',
  '104001',
  'england|cornwall|north cornwall',
  'north-cornwall',
)
const BUDE = tile('Bude', '39353', 'england|cornwall|bude', 'bude')
const LOOE = tile('Looe', '39372', 'england|cornwall|looe', 'looe')
const PADSTOW = tile('Padstow', '39354', 'england|cornwall|padstow', 'padstow')
const FOWEY = tile('Fowey', '39359', 'england|cornwall|fowey', 'fowey')
const SOUTH_CORNWALL = tile(
  'South Cornwall',
  '104002',
  'england|cornwall|south cornwall',
  'south-cornwall',
)
const PERRANPORTH = tile(
  'Perranporth',
  '39343',
  'england|cornwall|perranporth',
  'perranporth',
)
const LISKEARD = tile(
  'Liskeard',
  '39366',
  'england|cornwall|liskeard',
  'liskeard',
)
const ST_AUSTELL = tile(
  'St Austell',
  '39375',
  'england|cornwall|st austell',
  'st-austell',
)
const FALMOUTH = tile(
  'Falmouth',
  '39377',
  'england|cornwall|falmouth',
  'falmouth',
)
const MEVAGISSEY = tile(
  'Mevagissey',
  '39362',
  'england|cornwall|mevagissey',
  'mevagissey',
)
const CORNWALL = tile(
  'Cornwall',
  '39247',
  'england|south west england|cornwall',
  'cornwall',
)

const CORNWALL_V1: ExplorationTile[] = [
  NEWQUAY,
  ST_IVES,
  ST_MAWES,
  NORTH_CORNWALL,
  BUDE,
  LOOE,
  PADSTOW,
  FOWEY,
  SOUTH_CORNWALL,
  PERRANPORTH,
]

const CORNWALL_V2: ExplorationTile[] = [
  NEWQUAY,
  BUDE,
  FOWEY,
  PADSTOW,
  ST_MAWES,
  LISKEARD,
  ST_AUSTELL,
  ST_IVES,
  FALMOUTH,
  MEVAGISSEY,
]

const ST_IVES_V1: ExplorationTile[] = [
  CORNWALL,
  NEWQUAY,
  ST_MAWES,
  NORTH_CORNWALL,
  BUDE,
  LOOE,
  PADSTOW,
  FOWEY,
  SOUTH_CORNWALL,
  PERRANPORTH,
]

const ST_IVES_V2: ExplorationTile[] = [
  CORNWALL,
  NEWQUAY,
  BUDE,
  FOWEY,
  PADSTOW,
  ST_MAWES,
  LISKEARD,
  ST_AUSTELL,
  FALMOUTH,
  MEVAGISSEY,
]

export const getExplorationSets = (
  placesId?: string,
): ExplorationSets | null => {
  switch (placesId) {
    case CORNWALL_PLACES_ID:
      return { location: 'cornwall', v1: CORNWALL_V1, v2: CORNWALL_V2 }
    case ST_IVES_PLACES_ID:
      return { location: 'st_ives', v1: ST_IVES_V1, v2: ST_IVES_V2 }
    default:
      return null
  }
}
